import * as React from "react"
import {AlertSeeker} from "@components/ui";


export default function AppWrapperPageGlobalMessages({ globalMessages=[] }) {


	return <>
		{ globalMessages.map(({ title, message, ...props }, idx) => <AlertSeeker
			disableAccordion
			severity="warning"
			key={idx}
			title={title}
			{...props}
			sx={{ mb: 3, ...props?.sx }}
		>
			{message}
		</AlertSeeker>) }
	</>
}